// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cVo5","label":"styles_label__1O7Mf"};